module.exports = __webpack_public_path__ + "static/media/google.477376d3.png";